"use strict";
/**
 * createdBy cc 2016-6-24
 * 时间选择器
 * callback为下拉组件原有参数
 * fromdate,untildate为自定义的开始时间与结束时间
 * 功能为下拉组件基础上增加自定义时间功能
 */
angular.module('trsTimeSelectModule', []).
directive('trsTimeSelect', ['$location', "$q", '$filter', '$stateParams', '$state', '$timeout', 'modalDialog', function($location, $q, $filter, $stateParams, $state, $timeout, modalDialog) {
    return {
        restrict: 'EA',
        templateUrl: "./utils/trsTimeSelect/trsTimeSelect_tpl.html",
        scope: {
            placeholder: "@",
            callback: "&",
            fromdate: "=",
            untildate: "=",
            disabled: "=",
            focus: "="
        },
        // <trs-single-select selected-option="iWoAllSelected" callback="queryByiWoAll()" options="iWoAll" class="pull-left"></trs-single-select>
        link: function(scope, iElement, iAttrs) {
            var from, to, indx, $datepickerCalendar;
            init();
            /**
             * [init description]初始化
             */
            function init() {
                temp();
                if (scope.fromdate && scope.untildate) {
                    from = new Date(Date.parse(scope.fromdate));
                    to = new Date(Date.parse(scope.untildate));
                    scope.showDate = dateFormat(from) + '至' + dateFormat(to);
                } else {
                    from = to = new Date();
                }
                indx = 1;
                $datepickerCalendar = iElement.find('.datepicker-calendar');
                datePicker();
                bindBodyClick();
            }

            scope.$watch("fromdate", function() {
                from = new Date(Date.parse(scope.fromdate));
                to = new Date(Date.parse(scope.untildate));
                if (angular.isDefined(scope.fromdate)) {
                    if (scope.showDate != scope.placeholder && scope.showDate != '请选择时间') {
                        scope.showDate = dateFormat(from) + '至' + dateFormat(to);
                    }
                }
            });
            scope.closeDate = function(event) {
                if (event) event.stopPropagation();
                $timeout(function() {
                    scope.showDate = scope.placeholder ? scope.placeholder : '请选择时间';
                    var attr1 = iAttrs['fromdate'].split(".");
                    var attr2 = iAttrs['untildate'].split(".");
                    scope.$parent[attr1[0]][attr1[1]] = '';
                    scope.$parent[attr2[0]][attr2[1]] = '';
                    scope.myDatePircke.DatePickerClear();
                    iElement.find(".datepicker-calendar").click();
                    iElement.find(".datepicker-calendar").hide();
                    iElement.find(".date-range-field").attr("class", "date-range-field");
                    scope.callback();
                });
            };

            scope.$watch("$parent." + iAttrs['fromdate'].split(".")[0] + "." + iAttrs['fromdate'].split(".")[1], function(newV, oldV) {
                if (oldV !== "" && newV === "") {
                    scope.closeDate();
                }
            });

            /**
             * [datePicker description]调用时间控件
             */
            function datePicker() {
                scope.myDatePircke = $datepickerCalendar.DatePicker({
                    inline: true,
                    date: [from, to],
                    calendars: 1,
                    mode: 'range',
                    onChange: function(dates, el) {
                        var fromDate = dateFormat(dates[0]);
                        var untilDate = dateFormat(dates[1]);
                        if (indx == 2) {
                            $datepickerCalendar.removeClass('cur').hide();
                            var attr1 = iAttrs['fromdate'].split(".");
                            var attr2 = iAttrs['untildate'].split(".");
                            scope.$parent[attr1[0]][attr1[1]] = $filter('date')(fromDate, "yyyy-MM-dd").toString();
                            scope.$parent[attr2[0]][attr2[1]] = $filter('date')(untilDate, "yyyy-MM-dd").toString();
                            $timeout(function() {
                                if (new Date(fromDate).getTime() <= new Date(untilDate).getTime()) {
                                    scope.callback();
                                } else {
                                    modalDialog.alertType('时间检索失败', '开始时间不能大于结束时间', "error", false);
                                }
                            });
                            indx = 1;
                        } else {
                            indx++;
                            untilDate = " 结束日期";
                        }
                        $timeout(function() {
                            scope.showDate = fromDate + '至' + untilDate;
                        });
                    }
                });
            }
            /**
             * [dateFormat description]时间格式化
             */
            function dateFormat(date) {
                var year = date.getFullYear();
                var month = (date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
                var day = (date.getDate()) >= 10 ? (date.getDate()) : '0' + (date.getDate());
                return year + "-" + month + "-" + day;
            }

            function temp() {
                iElement.delegate('.date-range-field', 'click', function(event) {
                    $('.dropdown').removeClass('open');
                    // $('.datepicker-calendar').hide();
                    if ($(this).siblings().hasClass('cur')) {
                        $(this).siblings().removeClass('cur').hide();
                        iElement.find(".cur").removeClass('cur').hide();
                    } else {
                        $(this).siblings().addClass('cur').show();
                    }
                    $timeout(function() {
                        if (angular.isDefined(scope.focus)) {
                            scope.focus = true;
                        }
                    });
                    return false;
                });
                iElement.delegate('.date-range-field', 'mouseenter', function(event) {
                    if (scope.fromdate && scope.untildate)
                        $(this).addClass('acitve');
                    return false;
                });
                iElement.delegate('.date-range-field', 'mouseleave', function(event) {
                    $(this).removeClass('acitve');
                    return false;
                });
            }
            /**
             * [bindBodyClick description] 绑定body的点击事件
             * @return {[type]} [description]
             */
            function bindBodyClick() {
                /**
                 * [bodyClick description] 绑定事件
                 * @return {[type]} [description]
                 */
                scope.bodyClick = function(e) {
                    var $target = $(e.target);
                    if ($target.parents(".date-range-field").length > 0) return;
                    $timeout(function() {
                        if (angular.isDefined(scope.focus)) {
                            scope.focus = false;
                        }
                    });
                };
                $("body").bind("click", scope.bodyClick);
                scope.$on("$destroy", function() {
                    //$("body").unbind(scope.bodyClick);
                });
            }
        }
    };
}]);
